import apiClient from "@/app/api/client";
import { replaceParams, staffWorkdayEndpoints } from "@/app/api/endpoints";
import type {
	CreateStaffWorkdayRequest,
	StaffWorkday,
	SuccessResponse,
	UpdateStaffWorkdayRequest,
} from "../types";

export const staffWorkdayService = {
	async list(): Promise<StaffWorkday[]> {
		const response = await apiClient.get<SuccessResponse<StaffWorkday[]>>(
			staffWorkdayEndpoints.list
		);
		return response.data.data;
	},

	async getById(id: string): Promise<StaffWorkday> {
		const url = replaceParams(staffWorkdayEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<StaffWorkday>>(url);
		return response.data.data;
	},

	async create(data: CreateStaffWorkdayRequest): Promise<StaffWorkday> {
		const response = await apiClient.post<SuccessResponse<StaffWorkday>>(
			staffWorkdayEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdateStaffWorkdayRequest): Promise<StaffWorkday> {
		const url = replaceParams(staffWorkdayEndpoints.update, { id });
		const response = await apiClient.put<SuccessResponse<StaffWorkday>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(staffWorkdayEndpoints.delete, { id });
		await apiClient.delete(url);
	},
};
